module.exports = __webpack_public_path__ + "img/ToanVo.352d923a.jpeg";